import React, { Fragment, useEffect, useState } from "react";
import { useHistory } from "react-router";
import { useTranslation } from "react-i18next";
import RouteManager, { PAGE_ROUTES } from "../../../managers/RouteManager";
import AppManager from "../../../managers/AppManager";
import {
    DKLabel,
    DKButton,
    showLoader,
    removeLoader,
    showToast,
    showAlert,
    TOAST_TYPE
} from "deskera-ui-library";
import ic_arrow_back from "../../../assets/icons/ic_arrow_back.svg";
import ic_repeat from "../../../assets/icons/ic_repeat.png";
import ic_download from "../../../assets/icons/ic_download.png";
import USComplianceService from "../../../services/compliance/US/USComplianceService";
import AttachmentService, { Entity } from "../../../services/AttachmentService";
import { saveAs } from 'file-saver';
import i18next from "i18next";

function SignForm(props) {
    const history = useHistory();
    const { t } = useTranslation();

    const [formData, setFormData] = useState(null);
    const [formObject, setFromObject] = useState(null);
    const [fileURL, setFileURL] = useState(null);
    const [signatory, setSignatory] = useState(null);

    useEffect(() => {
        RouteManager.setPresenter({ props: { ...props, history: history } });
        AppManager.scrollToTop();

        if (USComplianceService.FORM) {
            const form = USComplianceService.FORM;
            setFormData(form);
            setSignatory(form.signatory);
            getSignedForm(form);
            USComplianceService.FORM = null;
        } else {
            if (props.renderAsStep) {
                props.onBack();
            } else {
                RouteManager.navigateToPage(PAGE_ROUTES.FILLING_AUTHORIZATION);
            }
        }
    }, []);

    const getSignedForm = (formData) => {
        if (formData.stage === "SIGNED") {
            downloadForm(formData);
        } else {
            generateForm(formData);
        }
    }

    const generateForm = (formData, isRegenerate) => {
        showLoader(t("LOADING_TEXT"));
        const payload = {
            formName: formData.id,
            signatory: formData.signatory
        };
        USComplianceService.getForm(formData.id, payload).then(
            (response) => {
                const fileURL = URL.createObjectURL(response);
                setFromObject(response);
                setFileURL(fileURL);
                if (isRegenerate) {
                    setFormData(formData);
                }
                removeLoader();
            }, (error) => {
                removeLoader();
                showToast(t("FAILED_LOAD_FORM"), TOAST_TYPE.FAILURE);
            }
        );
    }

    const downloadForm = (formData) => {
        showLoader(t("LOADING_TEXT"));
        AttachmentService.getPresignedURL(formData.signedFilePath).then(
            (response) => {
                AttachmentService.downloadFile(response).then(
                    (response) => {
                        removeLoader();
                        const blob = new Blob([response], { type: "application/pdf" });
                        const fileURL = URL.createObjectURL(blob);
                        setFileURL(fileURL);
                        setFromObject(blob);
                    }, (error) => {
                        removeLoader();
                        showToast(t("FAILED_LOAD_FORM"), TOAST_TYPE.FAILURE);
                    }
                )
            }, (error) => {
                removeLoader();
                showToast(t("FAILED_LOAD_FORM"), TOAST_TYPE.FAILURE);
            }
        );
    }

    const signAndSubmit = async () => {
        showLoader(t("SUBMITTING_TEXT"));

        const response = await AttachmentService.getUploadFileURL(formObject, Entity.PEOPLE_DOCUMENT)
        if (response?.relativePath) {
            const payload = {
                form: formData.id,
                signatory: signatory,
                signedFilePath: response.relativePath,
                stage: "SIGNED"
            };
    
            USComplianceService.signForm(formData.id, payload).then(
                (response) => {
                    removeLoader();
                    if (props.renderAsStep) {
                        props.onBack(true);
                    } else {
                        RouteManager.navigateToPage(PAGE_ROUTES.FILLING_AUTHORIZATION);
                    }
                }, (error) => {
                    removeLoader();
                    showToast(t("INTERNAL_SERVER_ERROR"), TOAST_TYPE.FAILURE);
                }
            );
        }else if(response?.status === 500 && response?.message?.includes("CONTENT_TYPE_NOT_ALLOWED")) {
            showAlert(i18next.t('FAIL_TO_UPLOAD'), i18next.t('FILE_FORMAT_TYPE_ERROR_MSG'));
        } else {
            console.log(response)
            showToast(t("INTERNAL_SERVER_ERROR"), TOAST_TYPE.FAILURE);
        }
    }

    const regenerateForm = () => {
        const form = {
            ...formData,
            stage: "UNSIGNED"
        };

        generateForm(form, true);
    }

    const renderForm = () => {
        return (
            <Fragment>
                <DKButton
                    icon={ic_arrow_back}
                    title={t("BACK")}
                    className="pl-0 p-v-0 pr-0 cursor-hand fw-b"
                    onClick={() => {
                        if (props.renderAsStep) {
                            props.onBack();
                        } else {
                            RouteManager.navigateToPage(PAGE_ROUTES.FILLING_AUTHORIZATION);
                        }
                    }}
                />
                <div className="row justify-content-center mb-s">
                    <DKLabel text={formData.name} className="fs-l fw-b text-gray" />
                </div>
                {fileURL && <div className="parent-width parent-height">
                    <embed
                        type="application/pdf"
                        src={fileURL + "#toolbar=0"}
                        width="100%"
                        style={{
                            height: "calc(100% - 130px)"
                        }}
                    />
                    {formData.stage !== "SIGNED" &&
                        <div className="row mt-m">
                            <div className="mr-l custom-scroll" style={{ textAlign: "justify", minWidth: "calc(100% - 153px)", maxHeight: "100px", overflowY: "auto" }}>
                                {formData.disclosureText && <Fragment>
                                    <span className="fw-b">{`You, ${signatory.signerName}, verify the following: `}</span>
                                    <span>{formData.disclosureText}</span>
                                </Fragment>}
                            </div>
                            <div className="m-v-l">
                                <DKButton
                                    title={t("SIGN_AND_SUBMIT")}
                                    className="fw-b bg-app text-white"
                                    style={{
                                        padding: "12px 16px"
                                    }}
                                    onClick={() => {
                                        signAndSubmit();
                                    }}
                                />
                            </div>
                        </div>
                    }
                    {formData.stage === "SIGNED" &&
                        <div className="row m-v-l justify-content-end">
                            <DKButton
                                icon={ic_download}
                                title={t("DOWNLOAD")}
                                className="fw-b bg-white text-gray border-m mr-xl"
                                style={{
                                    padding: "12px 16px"
                                }}
                                onClick={() => {
                                    if (formObject) {
                                        saveAs(formObject, `${formData.name}.pdf`);
                                    }
                                }}
                            />
                            <DKButton
                                icon={ic_repeat}
                                title={t("REGENERATE")}
                                className="fw-b bg-white text-gray border-m"
                                style={{
                                    padding: "12px 16px"
                                }}
                                onClick={() => {
                                    regenerateForm();
                                }}
                            />
                        </div>
                    }
                </div>}
            </Fragment>
        );
    }

    return (
        <Fragment>
            {!props.renderAsStep &&
                <div className="parent-width parent-height">
                    {formData && renderForm()}
                </div>
            }
            {props.renderAsStep && 
                <div className="parent-width p-v-l" style={{ height: "calc(80vh - 120px)" }}>
                    <div className="p-h-xxl parent-height">
                        {formData && renderForm()}
                    </div>
                </div>
            }
        </Fragment>
    );
}

export default SignForm;
